
import { isEmptyOrNullString } from '@packages/toolbox/dist/utils/validators';
import { DELAY_TOOLTIP } from 'SharedDir/constants/common';
import { computed, defineComponent, PropType } from 'vue';

type IconSize = 'small' | 'medium' | 'large';

const VALID_SIZES: Array<IconSize> = ['small', 'medium', 'large'];

export default defineComponent({
  name: 'SIconTooltiped',
  props: {
    name: {
      type: String,
      required: true,
    },
    bgColor: {
      type: String,
      default: '',
    },

    tooltip: {
      required: false,
      type: String,
      default: '',
    },
    size: {
      required: false,
      type: String,
      default: 'medium',
      validator: (val: IconSize) => VALID_SIZES.includes(val),
    },
    animated: {
      required: false,
      type: Boolean,
      default: false,
    },
    color: {
      required: false,
      type: String,
      default: '',
    },
  },
  methods: {
    isEmptyOrNullString,
  },
  emits: ['click'],
  setup(props, { emit }) {
    function isCustomIcon(iconName: string): boolean {
      return iconName.startsWith('s-');
    }

    const isVisibleTooltip = computed((): boolean => {
      return !isEmptyOrNullString(props.tooltip);
    });

    const isCustom = computed((): boolean => {
      return isCustomIcon(props.name || '');
    });

    return {
      emit,
      DELAY_TOOLTIP,
      isVisibleTooltip,
      isCustom,
    };
  },
});
